<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="transfer-popup">
    <h1>בחירת הוראות קבע להעברה</h1>
    <ul class="debit-list">
        <li>
            <div class="check-wrapper">
                <input class="form-check-input" type="checkbox" id="selectAll" (click)="selectAllTransactions()" />
                <label class="form-check-label" for="selectAll" [ngClass]="{ 'transaction-checked': allChecked }">
                    בית העסק
                </label>
                <!--<section class="example-section">
                    <mat-checkbox class="example-margin" [(ngModel)]="checked"> בית העסק </mat-checkbox>
                </section>-->
            </div>
            <span class="date"> תאריך ביצוע </span>

            <span class="sum"> סכום החיוב </span>
        </li>
        <li *ngFor="let transaction of transactions; let i = index">
            <div class="check-wrapper">
                <input class="form-check-input" type="checkbox" id="{{ i }}" (click)="selectTransaction(i)" />
                <label
                    class="form-check-label"
                    for="{{ i }}"
                    [ngClass]="{ 'transaction-checked': transaction.isChecked }"
                >
                    {{ transaction.merchantName }}
                </label>
            </div>
            <span class="date">{{ transaction.processingDate | date: 'dd.MM.yyyy' }} </span>
            <span class="sum"> {{ transaction.amount }} {{ getSymbol(transaction.currency) }} </span>
        </li>
    </ul>
    <div class="button-wrapper">
        <a (click)="transferDirectDebits()" title="" class="brand-button red-button"><span>העבר הוראות הקבע</span></a>
    </div>
    <div *ngIf="showErrorMsg" class="err-msg">
        <span>חובה לבחור לפחות הוראת קבע אחת</span>
    </div>
</div>